import { CustomerProvider, Customer, AbstractCustomerProvider } from "../../providers/customer";
import { CustomerService, AbstractCustomerService, AbstractCustomerSetter } from '../../services/customer';
import { createContext, useContext } from 'react';
import { useSetCustomer } from "../../hooks/useSetCustomer/useSetCustomer";
import {useUpdateCustomerAccessToken} from "../../hooks/useUpdateCustomerAccessToken/useUpdateCustomerAccessToken";


export const CustomerServiceContext = createContext<AbstractCustomerService>(
  new CustomerService({} as AbstractCustomerProvider , {
    setCustomer: (cus: Customer) => {},
    updateCustomer: (accessToken: string) => {}
  })
);

export const CustomerServiceContextConsumer = CustomerServiceContext.Consumer;
export const CustomerServiceContextProviderForTest = CustomerServiceContext.Provider;

const provider = new CustomerProvider();

export const CustomerServiceContextProvider = ({children}: {children: React.ReactNode}) => {
  const setCustomer = useSetCustomer();
  const updateCustomerAccessToken = useUpdateCustomerAccessToken();
  const setter: AbstractCustomerSetter = {
    setCustomer: setCustomer,
    updateCustomer: updateCustomerAccessToken
  }

  return (
    <CustomerServiceContext.Provider value={new CustomerService(provider, setter)}>
      {children}
    </CustomerServiceContext.Provider>
  )
}
